<template>
  <div class="add-workflow-job-item" @click="$emit('clicked')">
    <workflow-job-item
      :job="{ id: 0, name: '', sortOrder: 0 }"
      :entity-type="entityType"
      is-sample 
    />
    <quick-add-button :color="btnColor" size="medium"  />
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default defineComponent({
  name: 'AddWorkflowJobItem',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
  },

  emits: ['clicked'],

  data() {
    return {
      ColorAssistant,
      TextAssistant,
    }
  },

  computed: {
    btnColor(): string {
      return ColorAssistant.getEntityColor(this.entityType)
    },
  },
})
</script>

<style lang="scss">
.add-workflow-job-item {
  width: 100%;
  position: relative;
  cursor: pointer;

  > .quick-add-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>
